import { ObjectFieldModel, AllFieldTypes, SelectFieldModel } from '@cak-legacy/generation-schema-core';
import { IForm } from '../interface/form';
import { getPopupHint } from './getPopupHint';

import {
  IFormContentDataViewModel,
  IFormFieldContentViewModel,
  IFormSectionsViewModel,
} from '../interface/formContentData';

export class FormJsonModifier {
  addCmsContentToJsonDefinitionfunction = (form: IForm, cmsContentModel: IFormContentDataViewModel) => {
    form.form.title = cmsContentModel.title;
    form.form.flowSteps.forEach((step) => {
      if (step.isIntroduction) {
        if (cmsContentModel.introduction) {
          step.introText = cmsContentModel.introduction;
        }

        if (cmsContentModel.privacyText) {
          step.outroText = cmsContentModel.privacyText;
        }
      }
      step.sections?.forEach((section) => {
        for (const fieldName in section) {
          const field = section[fieldName];
          this.modifyFields(fieldName, field, cmsContentModel);
        }
      });
    });
  };

  modifyFields = (fieldName: string, field: AllFieldTypes, formContent: IFormContentDataViewModel) => {
    const formFieldContent: IFormFieldContentViewModel[] = formContent.formFieldContent;
    // Nested object
    if (field.type === 'object') {
      const properties = (field as ObjectFieldModel).properties;

      //modify section
      const matchingCmsContentField = this.getMathingSectionTitleFromCmsContent(fieldName, formContent);
      if (matchingCmsContentField) {
        this.addCmsContentToSection(field, matchingCmsContentField);
      }

      // Loop through all fields within the section with recursion
      for (const innerFieldName in properties) {
        const innerField = properties[innerFieldName];
        this.modifyFields(innerFieldName, innerField, formContent);
      }
    }
    // actual field
    else {
      const matchingCmsContentField = this.getMatchingFieldFromCmsContent(fieldName, formFieldContent);

      if (matchingCmsContentField) {
        this.addCmsContentToField(field, matchingCmsContentField);

        if (field.type === 'select') {
          this.addContentToSelectField(field as SelectFieldModel, matchingCmsContentField);
        }
      }
    }
  };

  getMatchingFieldFromCmsContent = (fieldName: string, formFieldContent: IFormFieldContentViewModel[]) => {
    return formFieldContent.find((field) => field.fieldName === fieldName);
  };

  getMathingSectionTitleFromCmsContent = (sectionName: string, formContent: IFormContentDataViewModel) => {
    return formContent.formSections?.find((section) => section.sectionName === sectionName);
  };

  addCmsContentToSection = (field: AllFieldTypes, cmsContentSection: IFormSectionsViewModel) => {
    field.label = cmsContentSection.sectionTitle;
    field.beforeFieldContent = cmsContentSection.sectionIntroduction;
  };

  addCmsContentToField = (field: AllFieldTypes, cmsContentField: IFormFieldContentViewModel) => {
    if (cmsContentField.label) {
      field.label = cmsContentField.label;
    }

    // popup hint is optional and may not be filled
    const cmsPopupHint = getPopupHint(cmsContentField.additionalInformation);
    if (cmsPopupHint.popupHint !== undefined) {
      field.popupHint = cmsPopupHint.popupHint;
    }
  };

  addContentToSelectField = (field: SelectFieldModel, cmsContentField: IFormFieldContentViewModel) => {
    if (!cmsContentField.formFieldOptions || cmsContentField.formFieldOptions.length <= 0) {
      return;
    }

    // Uitzondering om dit niet toe te kunnen passen bij regelingen (contactformulier)
    if (cmsContentField.fieldName.toLowerCase() !== 'regeling') {
      field.options = cmsContentField.formFieldOptions?.map((option) => {
        return {
          value: option.value,
          label: option.label,
        };
      });
    }
    if (!cmsContentField.formFieldOptions.some((option) => option.text)) {
      return;
    }

    const dict: Map<string, string> = new Map();

    cmsContentField.formFieldOptions?.forEach((option) => {
      dict.set(option.value, option.text ?? '');
    });

    field.optionToContentAfterText = dict;
  };
}
